<template>
  <!-- 问答板块 -->
  <div class="id_7 clear">

    <div class="title" v-if="data.title" v-html="data.title"></div>

    <div class="box">
      <div class="icon clear">
        <img class="fl" src="//img.webloom.cn/img/98a7f1d155dcd81668a644efa2ab5ce1.png">
        <div class="bold span fl">Q</div>
      </div>

      <div class="question" v-html="data.question"></div>

    </div>

    <div class="box">
      <div class="icon clear">
        <img class="fl" src="//img.webloom.cn/img/2d9a86c4615b2c0cd2b57e3f39be6f3c.png">
        <div class="bold span fl">A</div>
      </div>

      <div class="answer" v-html="data.answer"></div>

    </div>

  </div>
</template>

<script>

export default {
  props: {
    data: Object
  },
  name: 'id_7',
  data () {
    return {
    }
  }
}
</script>
<style lang="scss">
.id_7{
  word-wrap:break-word;
  .answer{
    img{
      width: 100%;
      margin: 24px 0;
    }
    .img_title{
      font-size: 14px;
      line-height: 20px;
      text-align: center;
      color: #909399;
      margin-top: 16px;
    }
  }
}
</style>

<style lang="scss" scoped>
.id_7{
  padding-top: 32px;
  padding-bottom: 32px;
  border-radius: 4px;
  margin: 32px 0;
  background-color: #fff;
  .title{
    font-size: 14px;
    line-height: 22px;
  }
  .box{
    border: 1px solid #DCDFE6;
    border-radius: 4px;
    padding: 24px;
    margin-top: 40px;
    position: relative;
    .icon{
      position: absolute;
      background-color: #fff;
      padding-left: 8px;
      padding-right: 8px;
      top: -15px;
      left: 24px;
      .span{
        line-height: 30px;
        font-size: 20px;
        margin-left: 8px;
      }
    }
    .question,.answer{
      font-size: 16px;
      line-height: 26px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/module/course/public/id_7.vue